import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-mockups',
    templateUrl: './mockups.component.html',
    styleUrls: ['./mockups.component.scss'],
    imports: [RouterOutlet]
})
export class MockupsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
